import CloseIcon from '@repo/ui/src/components/Icons/CloseIcon';
import { classNames } from '@repo/ui/src/utils/classNames';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';

export interface MessageProps {
  closeIcon?: boolean;
  closeLabel: string;
  text: string;
  setOpen: (open: boolean) => void;
}

const Message = ({ closeIcon, closeLabel, text, setOpen }: MessageProps) => {
  const { t } = useTranslation();

  return (
    <div>
      {closeIcon && (
        <button
          type="button"
          onClick={() => setOpen(false)}
          aria-label={
            closeLabel ||
            t('genericContent.closeIconButtonLabel', undefined, { default: 'close dialog' })
          }
          className="inline-flex items-center justify-center rounded-full p-3 border-0 bg-transparent cursor-pointer transition-colors hover:bg-black/[0.04] focus-visible:outline-none float-right text-brand-300"
        >
          <CloseIcon />
        </button>
      )}
      <p
        className={classNames(
          'text-white tra-text-web-body-m',
          closeIcon ? 'p-4 pr-8' : 'py-1 px-3',
        )}
      >
        {text}
      </p>
    </div>
  );
};

export default Message;
